/* ============================================================
   DE FRUCTAANINDEX — het weer, uur voor uur opgeteld tot een richtlijn.

   HET MODEL (naar Hoefnatuurlijk / Paard Natuurlijk, openbaar beschreven):
   · verbruik, dag en nacht, afhankelijk van de temperatuur:
       onder 5 °C niets, tot 10 °C 1, tot 15 °C 2, daarboven 3 eenheden per uur;
   · productie overdag, afhankelijk van de bewolking:
       zwaar bewolkt 1, licht bewolkt 2, onbewolkt 3 eenheden per uur,
       midden op de dag (ruim vier uur na zonsopgang en vóór zonsondergang) 1 extra;
   · vastgehouden bij kou: onder 5 °C 2 eenheden per uur erbij, dag en nacht.
   Netto per uur wordt bij de lopende index opgeteld, nooit onder nul en nooit
   boven PLAFOND: een plant kan maar zoveel opslaan, en zonder plafond zat de
   index na een week kou tot in de lente vast op de bovenste stand.
   De eenheden zijn rekenwaarden, geen gram per kilo; de index is een richtlijn.

   DE NIVEAUS. Een koele zonnige lentedag (nacht rond het vriespunt, overdag
   12 graden en zon) bouwt zo'n 40 tot 50 eenheden op; twee van die dagen is
   verhoogd, vier is hoog, een week kou is zeer hoog. Onder 5 °C loopt de index
   ook zonder zon op (+2 per uur), dus in een vorstperiode staat hij hoog: dat is
   ook wat het origineel doet en wat de dierenartsen zeggen over bevroren gras.
   De grenzen zijn in het voorjaar te ijken tegen de kaart van Hoefnatuurlijk.

   WEERDATA: Open-Meteo, veertien dagen terug en vier vooruit, per uur temperatuur,
   bewolking en dag/nacht, per dag zonsopgang en -ondergang. Rechtstreeks uit de
   browser op de gratis laag. Wie de commerciële laag wil, zet in de instellingen
   de URL van een eigen doorgeefluik (bijvoorbeeld een Cloudflare Worker die de
   sleutel toevoegt): een sleutel hoort niet in de paginabron.

   DE KAART: achttien plaatsen in Nederland en België in één aanroep, zelfde
   rekensom, een uur bewaard. Klik op een stip en de index springt erheen.

   Alles wat beweegt is een veer die uitrolt of een lijn die zich optekent.
   Niets loopt vanzelf, niets volgt de cursor. De themabewerker vervangt de
   sectie bij elke instelling: shopify:section:load start hem opnieuw.
   ============================================================ */
(function () {
  const NS = 'http://www.w3.org/2000/svg';
  const mk = (t, a) => { const e = document.createElementNS(NS, t); for (const k in a) e.setAttribute(k, a[k]); return e; };
  const komma = n => String(n).replace('.', ',');
  const DAGNAMEN = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
  const GRENZEN = { verhoogd: 40, hoog: 120, zeerHoog: 240, top: 400 };
  const PLAFOND = 400;
  const niveauVan = idx => idx >= GRENZEN.zeerHoog ? 'zeer-hoog' : idx >= GRENZEN.hoog ? 'hoog' : idx >= GRENZEN.verhoogd ? 'verhoogd' : 'laag';
  /* het niveau op de schaal van 0 tot 100: vier gelijke vakken */
  const niveauVanScore = sc => sc >= 75 ? 'zeer-hoog' : sc >= 50 ? 'hoog' : sc >= 25 ? 'verhoogd' : 'laag';
  /* HET DAGSIGNAAL (Armyan, 16-09: "het klopt niet, overal dezelfde waardes"): de voorraad
     uit het uurmodel is in een zachte zomer overal nul, en dan lijkt er niets aan de kaart te
     hangen. Daarom telt het weer van vandaag zelf ook mee, naar de dagtelling die Hoofwear
     openbaar gebruikt: basis 22, zon (+3/+10/+18), de nacht (+22 bij vorst tot -6 bij een
     warme nacht), groei overdag (-4/-7), een zachte nacht met een groeizame dag (-4), droogte
     (+3) of regen (-1), en de klassieke combinaties (koele nacht met veel zon +6, mogelijke
     grondvorst +6). 0 tot 100. */
  function dagpunten(dg, k) {
    if (!dg || dg.temperature_2m_min[k] == null || dg.temperature_2m_max[k] == null) return 0;
    const zon = (dg.sunshine_duration[k] || 0) / 3600, nacht = dg.temperature_2m_min[k], dag = dg.temperature_2m_max[k], regen = dg.precipitation_sum ? (dg.precipitation_sum[k] || 0) : 1;
    let sc = 22;
    sc += zon >= 8 ? 18 : zon >= 4 ? 10 : 3;
    sc += nacht <= 0 ? 22 : nacht <= 5 ? 14 : nacht <= 8 ? 6 : nacht <= 12 ? -3 : -6;
    if (dag >= 18) sc -= 7; else if (dag >= 10) sc -= 4;
    if (nacht >= 8 && dag >= 12) sc -= 4;
    if (regen < 0.5) sc += 3; else if (regen >= 3) sc -= 1;
    if (nacht > 0 && nacht <= 4 && zon >= 5) sc += 6;
    if (zon >= 8 && nacht <= 5) sc += 6;
    /* Hoofwear noemt <30 laag en <60 hoog; onze vakken liggen op 25 en 50, dus dezelfde telling maal 25/30 */
    return Math.max(0, Math.min(100, Math.round(sc * 25 / 30)));
  }
  /* het getal: de voorraad op de schaal, plus wat vandaag daar bovenop doet (in de ruimte die over is) */
  const totaal = (idx, dagsc) => { const v = voorraadScore(idx); return Math.min(100, Math.round(v + dagsc * (100 - v) / 100)); };
  const scoreX = sc => 6 + sc / 100 * 588;

  /* ---------- het model ---------- */
  /* TWEE MODELLEN, PER VELD DE BESTE (20-09-2026). Getoetst aan twaalf dagen KNMI-uurwaarnemingen
     op zeven stations (onderzoek/fructaanindex/bronnen/, met een onafhankelijke controle van de
     methode): Open-Meteo's "best_match" is voor Nederland het KNMI-model Harmonie. Harmonie en het
     Duitse ICON ontlopen elkaar in temperatuur niet aantoonbaar (uur 0,75 tegen 0,60 graden,
     nachtminimum 0,89 tegen 0,81); ICON is duidelijk beter in bewolking (17 tegen 21 procentpunt),
     Harmonie in zon; het gemiddelde van beide is het best voor zon en regen, maar het minimum van
     een gemiddelde ligt per constructie iets te warm. Daarom per veld: temperatuur en bewolking van
     ICON, zon en regen gemiddeld, daglicht en zonsopkomst van Harmonie; valt een model uit, dan
     neemt het andere het over. Alle modellen zijn op koele nachten ruim een graad te warm; dat
     wordt in oktober opnieuw gemeten zodra er echte koude nachten zijn.
     Open-Meteo geeft bij meerdere modellen de velden met een achtervoegsel; dit maakt er weer
     gewone velden van. */
  const MODELLEN = ['knmi_seamless', 'icon_seamless'];
  const VOORKEUR = { temperature_2m: 'icon_seamless', cloud_cover: 'icon_seamless', temperature_2m_min: 'icon_seamless', temperature_2m_max: 'icon_seamless', is_day: 'knmi_seamless', sunrise: 'knmi_seamless', sunset: 'knmi_seamless' };
  function meng(d) {
    for (const deel of ['hourly', 'daily']) {
      const blok = d[deel]; if (!blok) continue;
      const velden = {};
      for (const k of Object.keys(blok)) for (const m of MODELLEN) if (k.endsWith('_' + m)) { const basis = k.slice(0, -m.length - 1); (velden[basis] = velden[basis] || {})[m] = blok[k]; }
      for (const veld in velden) {
        if (blok[veld]) continue;
        const per = velden[veld], eerste = Object.values(per).find(r => r) || [];
        const getal = Object.values(per).some(r => r && r.some(v => typeof v === 'number'));
        const wil = VOORKEUR[veld];
        blok[veld] = eerste.map((_, i) => {
          if (wil && per[wil] && per[wil][i] != null) return per[wil][i];
          const w = MODELLEN.map(m => per[m] ? per[m][i] : null).filter(v => v != null);
          if (!w.length) return null;
          return getal ? w.reduce((a, b) => a + b, 0) / w.length : w[0];
        });
        if (veld === 'is_day') blok[veld] = blok[veld].map(v => v == null ? null : (v >= 0.5 ? 1 : 0));
      }
    }
    return d;
  }
  /* DE METING VAN NU (20-09-2026): Buienradar geeft elke tien minuten de meetstations van het
     KNMI door, vrij te lezen uit de browser. Staat er een station binnen dertig kilometer, dan
     is de temperatuur van dit uur de gemeten waarde en niet die van het model. Alleen Nederland
     plus Maastricht en Westdorpe; daarbuiten blijft het model. */
  const STATIONS_URL = 'https://data.buienradar.nl/2.0/feed/json';
  let stationsCache = null;
  async function stations() {
    if (stationsCache && Date.now() - stationsCache.t < 10 * 60e3) return stationsCache.lijst;
    try {
      const r = await fetch(STATIONS_URL); if (!r.ok) throw new Error('http ' + r.status);
      const j = await r.json();
      const lijst = ((j.actual || {}).stationmeasurements || []).filter(s => typeof s.temperature === 'number' && s.lat && s.lon)
        .map(s => ({ naam: String(s.stationname || '').replace(/^Meetstation /, ''), lat: s.lat, lon: s.lon, temp: s.temperature, grond: s.groundtemperature, zon: s.sunpower, regen: s.rainFallLastHour, tijd: s.timestamp }));
      stationsCache = { t: Date.now(), lijst }; return lijst;
    } catch (e) { console.warn('[fructaan stations]', e); return stationsCache ? stationsCache.lijst : []; }
  }
  const afstandKm = (a, b, c, d2) => { const R = 6371, p = Math.PI / 180, x = (c - a) * p, y = (d2 - b) * p, s2 = Math.sin(x / 2) ** 2 + Math.cos(a * p) * Math.cos(c * p) * Math.sin(y / 2) ** 2; return 2 * R * Math.asin(Math.sqrt(s2)); };
  async function dichtstbijStation(lat, lon) {
    const lijst = await stations(); let beste = null;
    for (const s of lijst) { const km = afstandKm(+lat, +lon, s.lat, s.lon); if (km <= 30 && (!beste || km < beste.km)) beste = { ...s, km }; }
    return beste;
  }
  function reken(d) {
    const h = d.hourly, dg = d.daily;
    const opkomst = (dg.sunrise || []).map(t => Date.parse(t)), ondergang = (dg.sunset || []).map(t => Date.parse(t));
    let idx = 0; const reeks = [];
    for (let i = 0; i < h.time.length; i++) {
      const temp = h.temperature_2m[i], cc = h.cloud_cover[i], dag = h.is_day[i];
      if (temp == null) { reeks.push({ t: h.time[i], idx }); continue; }
      const verbruik = temp < 5 ? 0 : temp < 10 ? 1 : temp < 15 ? 2 : 3;
      let prod = 0;
      if (dag) {
        prod = (cc == null || cc >= 75) ? 1 : cc >= 25 ? 2 : 3;
        const tt = Date.parse(h.time[i]), di = Math.floor(i / 24);
        if (opkomst[di] && ondergang[di] && tt - opkomst[di] > 4 * 3600e3 && ondergang[di] - tt > 4 * 3600e3) prod += 1;
      }
      if (temp < 5) prod += 2;
      idx = Math.min(PLAFOND, Math.max(0, idx + prod - verbruik));
      reeks.push({ t: h.time[i], idx, temp });
    }
    return reeks;
  }
  /* het uur van nu in de lokale tijd van de plaats (Open-Meteo geeft lokale tijden) */
  function uurNu(d, reeks) {
    const nuLokaal = new Date(Date.now() + (d.utc_offset_seconds || 0) * 1000).toISOString().slice(0, 13);
    let hi = reeks.findIndex(r => r.t.slice(0, 13) === nuLokaal);
    if (hi < 0) hi = Math.min(reeks.length - 1, 14 * 24 + new Date().getHours());
    return hi;
  }
  /* de stip op de schaal: vier gelijke vakken, binnen elk vak lineair */
  const voorraadScore = idx => Math.floor((stipX(idx) - 6) / 588 * 100);
  function stipX(idx) {
    const v = [0, GRENZEN.verhoogd, GRENZEN.hoog, GRENZEN.zeerHoog, GRENZEN.top];
    const w = 588 / 4; idx = Math.min(GRENZEN.top, Math.max(0, idx));
    for (let k = 0; k < 4; k++) if (idx <= v[k + 1]) return 6 + w * k + w * (idx - v[k]) / (v[k + 1] - v[k]);
    return 594;
  }
  /* de reden, in gewone woorden, uit de laatste drie dagen; mag de trend niet tegenspreken */
  function reden(d, nu) {
    const dg = d.daily, i = nu.dagIndex;
    const nachten = [], zon = [];
    for (let k = Math.max(0, i - 2); k <= i; k++) { nachten.push(dg.temperature_2m_min[k]); zon.push((dg.sunshine_duration[k] || 0) / 3600); }
    const koud = nachten.filter(t => t != null && t < 5).length, vorst = nachten.filter(t => t != null && t <= 0).length;
    const zonnig = zon.filter(z => z >= 6).length, zacht = nachten.filter(t => t != null && t >= 10).length;
    const trend = nu.trend, n = nu.n || niveauVan(nu.idx), w = nu.w || {};
    const koustuk = koud >= 1 ? 'Een koude nacht' : 'Koel weer';
    /* rijp gezien: dan is er vorst in jouw wei, wat het station ook mat; dat is dan de reden */
    if (w.rijp && n !== 'laag') return 'Rijp op het gras, dus vorst in jouw wei' + (zonnig >= 1 ? ' en zon' : '') + ': het gras houdt de suiker vast.' + (trend === 'stijgend' ? ' Het loopt nog op.' : '');
    if (n === 'laag') {
      if (trend === 'stijgend') return (zonnig >= 1 ? koustuk + ' en zon' : koustuk) + ': er bouwt suiker op, al is het nog weinig.';
      if (zacht >= 2) return 'Zachte nachten: het gras groeit door en verbruikt meer suiker dan het aanmaakt.';
      if (zonnig === 0) return 'Weinig zon de laatste dagen: er wordt nauwelijks suiker aangemaakt.';
      return 'Het gras verbruikt op dit moment meer dan het opbouwt.';
    }
    /* boven laag zonder koude nacht in de laatste drie: de voorraad is van eerder en wordt nu afgebroken */
    if (koud === 0) return trend === 'stijgend'
      ? 'Geen koude nacht de laatste dagen, maar zon bij koel weer: er komt nog suiker bij.'
      : 'Eerder opgebouwd bij kou; nu het zachter is verbruikt het gras de suiker weer.' + (trend === 'dalend' ? ' Het zakt.' : '');
    const opbouw = vorst >= 1 ? (vorst === 1 ? 'Eén nacht vorst' : vorst + ' nachten vorst') : koud >= 1 ? (koud === 1 ? 'Eén koude nacht' : koud + ' koude nachten') : 'Koel weer';
    const zonstuk = zonnig >= 1 ? (zonnig === 1 ? ' en een zonnige dag' : ' en ' + zonnig + ' zonnige dagen') : '';
    const richting = trend === 'stijgend' ? ' Het loopt nog op.' : trend === 'dalend' ? ' Het zakt weer.' : '';
    return opbouw + zonstuk + ': het gras houdt de suiker vast.' + richting;
  }

  /* ---------- de kaart: achttien plaatsen, zelfde projectie als snippets/donq-fructaan-kaart.liquid ---------- */
  const PROJ = { lon0: 2.3, lon1: 7.4, lat0: 49.4, lat1: 53.75, w: 600, h: 824 };
  const PLAATSEN = [
    /* Nederland (17, Armyan 16-09: meer steden in Nederland, iets minder in België) */
    ['Groningen', 53.219, 6.568], ['Leeuwarden', 53.201, 5.799], ['Emmen', 52.785, 6.897], ['Zwolle', 52.513, 6.094],
    ['Enschede', 52.220, 6.894], ['Alkmaar', 52.632, 4.749], ['Amsterdam', 52.373, 4.893], ['Den Haag', 52.078, 4.312],
    ['Rotterdam', 51.924, 4.479], ['Utrecht', 52.091, 5.121], ['Arnhem', 51.985, 5.899],
    ['Middelburg', 51.499, 3.611], ['Breda', 51.589, 4.776], ['Den Bosch', 51.697, 5.304], ['Eindhoven', 51.440, 5.470],
    ['Venlo', 51.370, 6.172], ['Maastricht', 50.851, 5.690],
    /* België (5) */
    ['Gent', 51.054, 3.725], ['Antwerpen', 51.220, 4.400], ['Brussel', 50.850, 4.350], ['Luik', 50.633, 5.567], ['Aarlen', 49.683, 5.817],
  ];
  const projecteer = (lat, lon) => ({ x: (lon - PROJ.lon0) / (PROJ.lon1 - PROJ.lon0) * PROJ.w, y: (PROJ.lat1 - lat) / (PROJ.lat1 - PROJ.lat0) * PROJ.h });

  function start(blok) {
    if (blok.dataset.friGestart) return;
    blok.dataset.friGestart = '1';
    const q = sel => blok.querySelector(sel);
    const form = q('[data-fri-form]'), invoer = q('[data-fri-plaats]'), gps = q('[data-fri-gps]');
    const status = q('[data-fri-status]'), uitkomst = q('[data-fri-uitkomst]'), onder = q('[data-fri-onder]');
    const el = {
      waar: q('[data-fri-waar]'), niveau: q('[data-fri-niveau]'), reden: q('[data-fri-reden]'),
      stip: q('[data-fri-stip]'), weer: q('[data-fri-weer]'), lijnen: q('[data-fri-lijnen]'),
      dagen: q('[data-fri-dagen]'), weeknoot: q('[data-fri-weeknoot]'), advies: q('[data-fri-adviestekst]'),
      kaartPunten: q('[data-fri-punten]'), kaartStatus: q('[data-fri-kaartstatus]'),
      getal: q('[data-fri-getal]'), redenen: q('[data-fri-redenen]'),
      rijp: q('[data-fri-rijp]'), nat: q('[data-fri-nat]'), bodem: q('[data-fri-bodem]'),
    };
    if (!form || !invoer || !uitkomst) return;
    let TEKSTEN = {};
    try { TEKSTEN = JSON.parse(q('[data-fri-teksten]').textContent); } catch (e) {}
    const woord = n => (TEKSTEN[n] && TEKSTEN[n].woord) ? TEKSTEN[n].woord : n;
    /* de gratis laag, of een eigen doorgeefluik dat de sleutel toevoegt */
    const basis = (blok.dataset.basis || '').trim().replace(/\/$/, '');
    const weerUrl = basis ? basis + '/v1/forecast' : 'https://api.open-meteo.com/v1/forecast';
    const geoUrl = basis ? basis + '/v1/search' : 'https://geocoding-api.open-meteo.com/v1/search';
    const rustig = matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- eigen waarnemingen ----------
       Het weerstation staat niet in jouw wei. Rijp op het gras is vorst, wat het
       station ook zei: dan telt het alsof er een koude heldere nacht bij kwam
       (+40, één vak). Zand droogt uit en zet het gras onder stress (+8%), klei
       houdt vocht en groei vast (-8%), veen en leem iets minder (-4%); natte grond
       na regen laat het gras doorgroeien en verbruiken (-10%). Kleine correcties,
       bewust: de meting blijft het weer. */
    const BODEM = { zand: 1.08, klei: 0.92, veen: 0.96, leem: 0.96 };
    function waarnemingen() {
      return { rijp: !!(el.rijp && el.rijp.checked), nat: !!(el.nat && el.nat.checked), bodem: el.bodem ? el.bodem.value : '' };
    }
    function corrigeer(idx, w, vanafVandaag, koud) {
      let v = idx;
      /* rijp: alleen vanaf vandaag, en niet als het station zelf al vorst mat (die nacht zit er dan al in) */
      if (w.rijp && vanafVandaag !== false && !w.vorstGemeten) v += 40;
      /* bodem en vocht werken via de groei; bij kou groeit er niets, dus dan tellen ze niet */
      if (!koud) {
        if (w.bodem && BODEM[w.bodem]) v *= BODEM[w.bodem];
        if (w.nat) v *= 0.9;
      }
      return Math.min(PLAFOND, Math.max(0, v));
    }
    try {
      const w = JSON.parse(localStorage.getItem('donq-fructaan-waarnemingen') || 'null');
      if (w) { if (el.nat) el.nat.checked = !!w.nat; if (el.bodem && w.bodem != null) el.bodem.value = w.bodem; }
      if (el.rijp) el.rijp.checked = false;   /* rijp begint altijd uit; zie rijpVoor */
      try { sessionStorage.removeItem('donq-fructaan-rijp'); } catch (e) {}
    } catch (e) {}
    let laatsteWeer = null, laatstePlek = null;   /* {d, naam} van de laatst getoonde plaats, voor een nieuwe correctie */
    let rijpVoor = '';   /* de plaats waarvoor de rijp is aangevinkt; leeg = geen rijp */
    [el.rijp, el.nat, el.bodem].forEach(x => x && x.addEventListener('change', () => {
      /* bodem en vocht blijven; rijp is een waarneming van vanochtend en geldt alleen deze sessie */
      /* rijp wordt NIET bewaard (Armyan, 20-09-2026: een vinkje van een eerdere keer gaf een getal dat
         niet bij de kaart paste). Hij geldt alleen op deze pagina, en alleen voor de plaats waar je hem zette. */
      try { const w = waarnemingen(); localStorage.setItem('donq-fructaan-waarnemingen', JSON.stringify({ nat: w.nat, bodem: w.bodem })); sessionStorage.removeItem('donq-fructaan-rijp'); } catch (e) {}
      rijpVoor = (el.rijp && el.rijp.checked && laatstePlek) ? laatstePlek.naam : '';
      if (laatsteWeer) verwerk(laatsteWeer.d, laatsteWeer.naam);
    }));
    /* het getal 0 tot 100: de plek op de schaal, vier gelijke vakken van 25 */
    /* (de voorraad op de schaal staat bovenin als voorraadScore) */

    /* ---------- weer opvragen; het laatste verzoek wint, ook over een zoekopdracht heen ---------- */
    let ophaling = 0;
    async function toon(lat, lon, naam, mijn) {
      laatstePlek = { lat, lon, naam };
      zetEzel(lat, lon);
      if (mijn == null) mijn = ++ophaling;
      status.textContent = 'Weer ophalen voor ' + naam + '…';
      const url = weerUrl + '?latitude=' + encodeURIComponent(lat) + '&longitude=' + encodeURIComponent(lon) +
        '&hourly=temperature_2m,cloud_cover,is_day&daily=temperature_2m_min,temperature_2m_max,sunshine_duration,precipitation_sum,sunrise,sunset' +
        '&models=' + MODELLEN.join(',') + '&timezone=auto&past_days=14&forecast_days=4';
      let d;
      try {
        const r = await fetch(url); if (!r.ok) throw new Error('http ' + r.status);
        d = meng(await r.json()); if (!d || !d.hourly || !d.daily || !d.hourly.temperature_2m) throw new Error('geen weerdata');
      } catch (e) {
        if (mijn !== ophaling) return;
        /* wat er stond hoorde bij een andere plaats: weg ermee, geen oude uitkomst onder een nieuwe naam */
        uitkomst.hidden = true; if (onder) onder.hidden = true;
        status.textContent = 'Het weer kon niet worden opgehaald. Probeer het zo nog eens.';
        console.warn('[fructaan]', e); return;
      }
      if (mijn !== ophaling) return;
      /* de gemeten temperatuur van dit uur, als er een station in de buurt is */
      d.meting = null;
      try {
        const st = await dichtstbijStation(lat, lon);
        if (mijn !== ophaling) return;
        if (st) {
          const hi = uurNu(d, reken(d));
          if (d.hourly.temperature_2m[hi] != null) { d.hourly.temperature_2m[hi] = st.temp; d.meting = st; }
        }
      } catch (e) {}
      laatsteWeer = { d, naam };
      verwerk(d, naam);
      /* onthouden: een plaatsnaam blijvend; de eigen locatie alleen deze sessie, afgerond op
         ongeveer honderd meter, en nooit ongevraagd opnieuw opgestuurd na een nieuw bezoek */
      try {
        const rec = JSON.stringify({ naam, lat: +(+lat).toFixed(3), lon: +(+lon).toFixed(3) });
        if (naam === 'jouw locatie') { sessionStorage.setItem('donq-fructaan-plaats', rec); localStorage.removeItem('donq-fructaan-plaats'); }
        else { localStorage.setItem('donq-fructaan-plaats', rec); sessionStorage.removeItem('donq-fructaan-plaats'); }
      } catch (e) {}
    }

    function verwerk(d, naam) {
      /* de rijp-vink volgt de plaats: aan als hij voor deze plaats is gezet, anders uit */
      if (el.rijp) el.rijp.checked = rijpVoor !== '' && rijpVoor === naam;
      const w = waarnemingen();
      const ruw = reken(d), hi = uurNu(d, ruw);
      const dag = Math.floor(hi / 24), vandaag = dag * 24, dg = d.daily;
      /* het station mat vandaag zelf vorst: dan zit de rijp al in de index */
      w.vorstGemeten = dg.temperature_2m_min[dag] != null && dg.temperature_2m_min[dag] <= 0;
      /* per dag: zo koud dat het gras niet groeit (vorst, of overdag onder de vijf graden) */
      const koudDag = k => (dg.temperature_2m_min[k] != null && dg.temperature_2m_min[k] <= 0) || (dg.temperature_2m_max[k] != null && dg.temperature_2m_max[k] < 5);
      w.koudVandaag = koudDag(dag);
      /* de correctie geldt voor elk uur, zodat ook de week en de trend meebewegen */
      const reeks = ruw.map((r, k) => ({ t: r.t, temp: r.temp, idx: corrigeer(r.idx, w, k >= vandaag, koudDag(Math.floor(k / 24))) }));
      /* het getal per dag: de voorraad op dit uur plus het dagsignaal van die dag */
      const scoreVanDag = k => { const r = reeks[k * 24 + (hi % 24)]; return r ? totaal(r.idx, dagpunten(dg, k)) : null; };
      const nu = { idx: reeks[hi].idx, dagIndex: dag, trend: '', w, dagsc: dagpunten(dg, dag), scoreVanDag };
      nu.score = totaal(nu.idx, nu.dagsc); nu.n = niveauVanScore(nu.score);
      /* dezelfde som zonder wat je zelf ziet: dat is het getal dat de kaart voor deze plaats toont */
      nu.zonder = totaal(ruw[hi].idx, nu.dagsc);
      const gisteren = scoreVanDag(Math.max(0, dag - 1));
      nu.trend = gisteren == null ? 'stabiel' : nu.score - gisteren > 6 ? 'stijgend' : gisteren - nu.score > 6 ? 'dalend' : 'stabiel';
      schrijf(d, nu, reeks, naam, hi);
    }

    /* ---------- de puntsgewijze uitleg: wat het weer en je waarnemingen elk doen ---------- */
    function redenen(d, nu) {
      const dg = d.daily, i = nu.dagIndex, uit = [];
      const nacht = dg.temperature_2m_min[i], dag = dg.temperature_2m_max[i], zon = (dg.sunshine_duration[i] || 0) / 3600, regen = dg.precipitation_sum[i] || 0;
      const komende = dg.temperature_2m_min[i + 1];
      if (nacht != null) {
        if (nacht <= 0) uit.push('<b>Vorst afgelopen nacht</b> (' + komma(Math.round(nacht)) + ' °C): het gras groeide niet en hield alle suiker vast.');
        else if (nacht < 5) uit.push('<b>Koude nacht</b> (' + komma(Math.round(nacht)) + ' °C): nauwelijks groei, dus weinig verbruik van suiker.');
        else if (nacht < 10) uit.push('<b>Koele nacht</b> (' + komma(Math.round(nacht)) + ' °C): het gras verbruikte maar een deel van de suiker.');
        else uit.push('<b>Zachte nacht</b> (' + komma(Math.round(nacht)) + ' °C): het gras groeide door en verbruikte suiker.');
      }
      if (zon >= 8) uit.push('<b>Veel zon</b> (' + zon.toFixed(0) + ' uur): het gras maakte volop suiker aan.');
      else if (zon >= 4) uit.push('<b>Redelijk wat zon</b> (' + zon.toFixed(0) + ' uur): een matige aanmaak van suiker.');
      else uit.push('<b>Weinig zon</b> (' + zon.toFixed(0) + ' uur): nauwelijks aanmaak van suiker.');
      if (dag != null) {
        if (dag >= 18) uit.push('<b>Warm overdag</b> (' + komma(Math.round(dag)) + ' °C): het gras groeit en verbruikt wat het aanmaakt.');
        else if (dag >= 10) uit.push('<b>Groeizaam overdag</b> (' + komma(Math.round(dag)) + ' °C): het gras verbruikt een deel van de suiker.');
        else uit.push('<b>Koud overdag</b> (' + komma(Math.round(dag)) + ' °C): het gras groeit nauwelijks en verbruikt bijna niets.');
      }
      if (regen >= 3) uit.push('<b>Regen</b> (' + komma(regen.toFixed(1)) + ' mm): telt niet mee in de index, maar vocht houdt het gras aan het groeien.');
      else if (regen < 0.5 && zon >= 6) uit.push('<b>Droge dag</b>: telt niet mee in de index; houdt de droogte aan, dan raakt het gras onder stress en spaart het.');
      if (komende != null && komende < 5) uit.push('<b>Komende nacht ' + komma(Math.round(komende)) + ' °C</b>: kou op komst, de suiker blijft zitten.');
      else if (komende != null && komende >= 10) uit.push('<b>Komende nacht ' + komma(Math.round(komende)) + ' °C</b>: zacht, het gras verbruikt vannacht door.');
      const w = nu.w || {};
      if (w.rijp) uit.push(w.vorstGemeten
        ? '<b>Rijp op het gras</b>: het weerstation mat vannacht zelf ook vorst, dus die nacht zit al in de index.'
        : '<b>Rijp op het gras</b>: dat is vorst in jouw wei, wat het weerstation ook mat. Meegeteld.');
      /* bodem en vocht werken via de groei; vandaag te koud om te groeien, dan tellen ze vandaag niet */
      const kouNoot = w.koudVandaag ? ' Vandaag telt dat niet: bij kou groeit er niets.' : '';
      if (w.bodem === 'zand') uit.push('<b>Zandgrond</b> droogt snel uit en zet het gras onder stress: iets meer opslag.' + kouNoot);
      if (w.bodem === 'klei') uit.push('<b>Kleigrond</b> houdt vocht vast: bij groeizaam weer verbruikt het gras langer door, iets minder opslag.' + kouNoot);
      if (w.bodem === 'veen' || w.bodem === 'leem') uit.push('<b>' + (w.bodem === 'veen' ? 'Veengrond' : 'Leem of gemengde grond') + '</b> houdt redelijk vocht vast: iets minder opslag.' + kouNoot);
      if (w.nat) uit.push('<b>Natte bodem</b>: zodra het warm genoeg is, groeit het gras door en verbruikt het suiker; iets lager gerekend.' + kouNoot);
      /* hooguit acht regels: vijf van het weer en drie eigen waarnemingen, dus er valt er nooit een af */
      return uit.slice(0, 8);
    }

    /* DE FACTOREN (Armyan, 20-09-2026: "bij de index de info-bolletjes, maar niet te vol"): hooguit
       vier tegels pal onder de index, elk één maat en één woord, met een stip die zegt welke kant
       hij de index op duwt (omhoog = suiker blijft zitten, omlaag = het gras verbruikt). De lange
       uitleg staat eronder bij "Wat meetelt"; dit is de samenvatting in één oogopslag. */
    function factoren(d, nu) {
      const dg = d.daily, i = nu.dagIndex, uit = [];
      const nacht = dg.temperature_2m_min[i], dag = dg.temperature_2m_max[i], zon = (dg.sunshine_duration[i] || 0) / 3600, regen = dg.precipitation_sum[i] || 0;
      const komende = dg.temperature_2m_min[i + 1], w = nu.w || {};
      const gr = n => komma(Math.round(n)) + ' °C';
      if (nacht != null) uit.push(nacht <= 0 ? { kop: 'Afgelopen nacht', waarde: gr(nacht), woord: 'vorst, suiker blijft', richting: 'omhoog' }
        : nacht < 5 ? { kop: 'Afgelopen nacht', waarde: gr(nacht), woord: 'koud, weinig verbruik', richting: 'omhoog' }
        : nacht < 10 ? { kop: 'Afgelopen nacht', waarde: gr(nacht), woord: 'koel', richting: 'neutraal' }
        : { kop: 'Afgelopen nacht', waarde: gr(nacht), woord: 'zacht, verbruik', richting: 'omlaag' });
      uit.push(zon >= 8 ? { kop: 'Zon', waarde: zon.toFixed(0) + ' uur', woord: 'volop aanmaak', richting: 'omhoog' }
        : zon >= 4 ? { kop: 'Zon', waarde: zon.toFixed(0) + ' uur', woord: 'matige aanmaak', richting: 'neutraal' }
        : { kop: 'Zon', waarde: zon.toFixed(0) + ' uur', woord: 'weinig aanmaak', richting: 'omlaag' });
      if (dag != null) uit.push(dag >= 18 ? { kop: 'Overdag', waarde: gr(dag), woord: 'warm, groei', richting: 'omlaag' }
        : dag >= 10 ? { kop: 'Overdag', waarde: gr(dag), woord: 'groeizaam', richting: 'neutraal' }
        : { kop: 'Overdag', waarde: gr(dag), woord: 'koud, geen groei', richting: 'omhoog' });
      /* de vierde tegel: wat het meest zegt over vannacht en morgen */
      if (w.rijp) uit.push({ kop: 'Rijp gezien', waarde: 'jouw melding', woord: 'tik om weg te halen', richting: 'omhoog', knop: true });
      else if (komende != null && komende < 5) uit.push({ kop: 'Komende nacht', waarde: gr(komende), woord: 'kou op komst', richting: 'omhoog' });
      else if (regen >= 3) uit.push({ kop: 'Regen', waarde: komma(regen.toFixed(1)) + ' mm', woord: 'gras groeit door', richting: 'omlaag' });
      else if (komende != null) uit.push({ kop: 'Komende nacht', waarde: gr(komende), woord: komende >= 10 ? 'zacht' : 'koel', richting: komende >= 10 ? 'omlaag' : 'neutraal' });
      return uit.slice(0, 4);
    }
    const RICHTING_TEKST = { omhoog: 'duwt de index omhoog', omlaag: 'duwt de index omlaag', neutraal: 'houdt de index waar hij is' };
    function schrijfFactoren(d, nu) {
      const vak = q('[data-fri-factoren]'); if (!vak) return;
      vak.innerHTML = '';
      factoren(d, nu).forEach((f, k) => {
        const li = document.createElement('li'); li.className = 'fri__factor' + (f.knop ? ' fri__factor--knop' : ''); li.dataset.richting = f.richting; li.style.setProperty('--v', (k * 70) + 'ms');
        const binnen = '<i class="fri__factorstip" aria-hidden="true"></i><span class="fri__factorkop">' + f.kop + '</span><span class="fri__factorwaarde">' + f.waarde + ' · ' + f.woord + '</span><span class="fri__sr">, ' + RICHTING_TEKST[f.richting] + '</span>';
        li.innerHTML = f.knop ? '<button type="button" class="fri__factorknop">' + binnen + '</button>' : binnen;
        if (f.knop) li.querySelector('button').addEventListener('click', () => { if (el.rijp) { el.rijp.checked = false; el.rijp.dispatchEvent(new Event('change', { bubbles: true })); } });
        vak.appendChild(li);
      });
    }

    /* ---------- schrijven ---------- */
    let stipStand = 6, stipDoel = 6, stipV = 0, stipRaf = 0, vorigeTik = 0;
    function veerStip() {
      if (!el.stip) return;
      const tik = t => {
        const dt = Math.min(1 / 30, Math.max(1 / 240, vorigeTik ? (t - vorigeTik) / 1000 : 1 / 60)); vorigeTik = t;
        stipV += (120 * (stipDoel - stipStand) - 22 * stipV) * dt; stipStand += stipV * dt;
        if (Math.abs(stipDoel - stipStand) < 0.05 && Math.abs(stipV) < 0.05) { stipStand = stipDoel; stipV = 0; stipRaf = 0; el.stip.setAttribute('cx', stipStand.toFixed(1)); return; }
        el.stip.setAttribute('cx', stipStand.toFixed(1)); stipRaf = requestAnimationFrame(tik);
      };
      if (rustig) { stipStand = stipDoel; el.stip.setAttribute('cx', stipStand.toFixed(1)); return; }
      if (!stipRaf) { vorigeTik = 0; stipRaf = requestAnimationFrame(tik); }
    }
    function schrijf(d, nu, reeks, naam, hi) {
      const n = nu.n, tekst = TEKSTEN[n] || {};
      uitkomst.hidden = false; if (onder) onder.hidden = false;
      blok.dataset.niveau = n;
      /* Armyan (20-09-2026): "op de kaart staat een ander getal". De kaart rekent alleen met het weer;
         hier tellen rijp, natte bodem en grondsoort mee. Dan staat het verschil erbij, met het kale getal. */
      el.waar.textContent = 'Voor ' + naam + '.' + (nu.zonder !== nu.score ? ' Met wat je zelf ziet meegeteld; alleen op het weer is het ' + nu.zonder + ', zoals op de kaart.' : '');
      el.niveau.textContent = woord(n);
      if (el.getal) el.getal.textContent = String(nu.score);
      el.reden.textContent = reden(d, nu);
      if (el.redenen) { el.redenen.innerHTML = ''; redenen(d, nu).forEach(t => { const li = document.createElement('li'); li.innerHTML = t; el.redenen.appendChild(li); }); }
      blok.querySelectorAll('[data-fri-zone]').forEach(z => z.classList.toggle('is-aan', z.dataset.friZone === n));
      stipDoel = scoreX(nu.score); veerStip();
      const dg = d.daily, i = nu.dagIndex;
      const zon = ((dg.sunshine_duration[i] || 0) / 3600).toFixed(0);
      /* de afgelopen nacht is wat er is gebeurd; de komende nacht is waar het model op draait */
      const komende = dg.temperature_2m_min[i + 1];
      schrijfFactoren(d, nu);
      /* onder de tegels alleen nog wat de tegels niet zeggen: de meting van dit uur en de regen van vandaag */
      el.weer.textContent = (dg.precipitation_sum[i] >= 1 && !(dg.precipitation_sum[i] >= 3) ? 'Vandaag ' + komma(dg.precipitation_sum[i].toFixed(1)) + ' mm regen. ' : '') +
        (d.meting ? 'Nu gemeten bij ' + d.meting.naam + ' (' + Math.round(d.meting.km) + ' km): ' + komma(d.meting.temp.toFixed(1)) + ' °C' + (typeof d.meting.grond === 'number' ? ', aan de grond ' + komma(d.meting.grond.toFixed(1)) + ' °C' : '') + '.' : '');
      void zon; void komende;
      /* de week: per dag de stand op ditzelfde uur, zodat punt, woord en weeknoot
         op dezelfde klok meten; de dagen na vandaag zijn verwachting */
      const dagen = [];
      for (let k = i - 7; k <= Math.min(dg.time.length - 1, i + 3); k++) {
        if (k < 0) continue;
        const sc = nu.scoreVanDag(k);
        if (sc == null) continue;
        dagen.push({ datum: dg.time[k], max: sc, verwacht: k > i, vandaag: k === i });
      }
      tekenWeek(dagen);
      const komend = dagen.filter(x => x.verwacht), laatst = komend[komend.length - 1];
      el.weeknoot.textContent = laatst ? 'De verwachting voor de komende dagen: ' + (niveauVanScore(laatst.max) === n ? 'het blijft ' : '') + woord(niveauVanScore(laatst.max)).toLowerCase() + '.' : '';
      el.advies.textContent = tekst.advies || '';
      status.textContent = '';
    }
    function tekenWeek(dagen) {
      if (!el.lijnen) return;
      el.lijnen.innerHTML = ''; el.dagen.innerHTML = '';
      if (!dagen.length) return;
      const top = 110;
      const L = 28, R = 588, B = 140, T = 16;
      const x = j => L + (R - L) * (dagen.length === 1 ? 0.5 : j / (dagen.length - 1));
      const y = v => B - (B - T) * v / top;
      [['verhoogd', 25], ['hoog', 50], ['zeer hoog', 75]].forEach(([w, v]) => {
        el.lijnen.appendChild(mk('line', { class: 'fri__grens-lijn', x1: L, y1: y(v).toFixed(1), x2: R, y2: y(v).toFixed(1) }));
        const t = mk('text', { class: 'fri__grens-woord', x: R, y: (y(v) - 4).toFixed(1), 'text-anchor': 'end' }); t.textContent = w; el.lijnen.appendChild(t);
      });
      const pts = dagen.map((x2, j) => [x(j), y(x2.max)]);
      const iVandaag = dagen.findIndex(x2 => x2.vandaag);
      const pad = (van, tot) => pts.slice(van, tot + 1).map((p, j) => (j ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join(' ');
      const einde = iVandaag < 0 ? pts.length - 1 : iVandaag;
      const gemeten = mk('path', { class: 'fri__lijn', d: pad(0, einde) });
      el.lijnen.appendChild(gemeten);
      let verwacht = null;
      if (iVandaag >= 0 && iVandaag < pts.length - 1) { verwacht = mk('path', { class: 'fri__lijn fri__lijn--verwacht', d: pad(iVandaag, pts.length - 1) }); el.lijnen.appendChild(verwacht); }
      dagen.forEach((x2, j) => {
        el.lijnen.appendChild(mk('circle', { class: 'fri__punt' + (x2.vandaag ? ' fri__punt--nu' : '') + (x2.verwacht ? ' fri__punt--verwacht' : ''), 'data-niveau': niveauVanScore(x2.max), cx: x(j).toFixed(1), cy: y(x2.max).toFixed(1), r: x2.vandaag ? 6.5 : 4.5 }));
        const dt = new Date(x2.datum + 'T12:00:00');
        const om = !x2.vandaag && Math.abs(j - iVandaag) % 2 === 1;
        const t = mk('text', { class: 'fri__dag' + (x2.vandaag ? ' fri__dag--nu' : '') + (om ? ' fri__dag--om' : ''), x: x(j).toFixed(1), y: 168, 'text-anchor': 'middle' });
        t.textContent = x2.vandaag ? 'vandaag' : DAGNAMEN[dt.getDay()] + ' ' + dt.getDate();
        el.dagen.appendChild(t);
      });
      /* optekenen: eerst de gemeten lijn, dan de verwachting; het streepjespatroon
         komt pas ná het optekenen, anders schuift het alleen van fase */
      if (rustig) return;
      const teken = (p, klaar) => {
        const len = p.getTotalLength();
        p.style.strokeDasharray = String(len); p.style.strokeDashoffset = String(len);
        requestAnimationFrame(() => { p.style.transition = 'stroke-dashoffset .9s cubic-bezier(.2,.7,.2,1)'; p.style.strokeDashoffset = '0'; });
        p.addEventListener('transitionend', () => { p.style.transition = ''; if (klaar) klaar(); }, { once: true });
      };
      if (verwacht) verwacht.style.strokeDasharray = '0 9999';
      teken(gemeten, () => { if (verwacht) teken(verwacht, () => { verwacht.style.strokeDasharray = '6 6'; verwacht.style.strokeDashoffset = '0'; }); });
    }

    /* ---------- de kaart ---------- */
    let gekozenPlaats = '', laatsteStanden = [];
    /* DE NAMEN ZOEKEN EEN VRIJ PLEKJE (Armyan, 19-09-2026: "ziet er rommelig uit").
       Eerst stond elke naam rechts van de stip, tenzij daar een buur zat; op de telefoon
       liepen ze dan over elkaar en over de kust heen. Nu krijgt elke plaats, van noord naar
       zuid, de eerste van acht standen (rechts, links, boven, onder, en de vier schuine) waar
       het kader van naam en getal geen andere stip en geen eerder gezette naam raakt en
       binnen de kaart blijft. De maten zijn geschat op de letterbreedte van de sans. */
    function plaatsNamen(standen, fs) {
      const punten = PLAATSEN.map(([naam, lat, lon], i) => ({ naam, i, p: projecteer(lat, lon), st: standen[i] }));
      const breed = q => fs * 0.56 * q.naam.length + (q.st ? 7 + fs * 0.62 * String(q.st.score).length : 0);
      const hoog = fs * 1.15;
      const raakt = (a, b) => a.x0 < b.x1 && a.x1 > b.x0 && a.y0 < b.y1 && a.y1 > b.y0;
      const stipvak = q => ({ x0: q.p.x - 13, x1: q.p.x + 13, y0: q.p.y - 13, y1: q.p.y + 13 });
      const gezet = [];
      const uit = {};
      /* boven de gekozen stip staat het ezeltje: dat vak is voor iedereen verboden terrein */
      const gek = punten.find(q => q.naam === gekozenPlaats);
      if (gek) gezet.push({ x0: gek.p.x - 26, x1: gek.p.x + 26, y0: gek.p.y - 50, y1: gek.p.y - 2 });
      const kandidaten = (q, w) => {
        const { x, y } = q.p, h = hoog, a = 16, d = 14;
        return [
          { k: 'rechts',      x0: x + a,     y0: y - h / 2,     anker: 'start' },
          { k: 'links',       x0: x - a - w, y0: y - h / 2,     anker: 'end' },
          { k: 'boven',       x0: x - w / 2, y0: y - d - h,     anker: 'middle' },
          { k: 'onder',       x0: x - w / 2, y0: y + d,         anker: 'middle' },
          { k: 'rechtsboven', x0: x + 10,    y0: y - d - h * .8, anker: 'start' },
          { k: 'rechtsonder', x0: x + 10,    y0: y + d - h * .2, anker: 'start' },
          { k: 'linksboven',  x0: x - 10 - w, y0: y - d - h * .8, anker: 'end' },
          { k: 'linksonder',  x0: x - 10 - w, y0: y + d - h * .2, anker: 'end' },
        ].map(c => ({ ...c, x1: c.x0 + w, y1: c.y0 + h }));
      };
      const overlap = (a, b) => Math.max(0, Math.min(a.x1, b.x1) - Math.max(a.x0, b.x0)) * Math.max(0, Math.min(a.y1, b.y1) - Math.max(a.y0, b.y0));
      punten.slice().sort((a, b) => a.p.y - b.p.y).forEach(q => {
        const w = breed(q);
        let beste = null, minst = Infinity;
        for (const c of kandidaten(q, w)) {
          const binnen = c.x0 >= 4 && c.x1 <= PROJ.w - 4 && c.y0 >= 4 && c.y1 <= PROJ.h - 4;
          let botst = 0;
          for (const o of punten) if (o !== q) botst += overlap(c, stipvak(o));
          for (const g of gezet) botst += overlap(c, { x0: g.x0 - 4, x1: g.x1 + 4, y0: g.y0 - 2, y1: g.y1 + 2 });
          const straf = botst + (binnen ? 0 : 1e6);
          if (straf === 0) { beste = c; break; }
          if (straf < minst) { minst = straf; beste = c; }
        }
        gezet.push(beste);
        /* de tekstbasis staat op driekwart van het vak */
        uit[q.naam] = { x: beste.anker === 'start' ? beste.x0 : beste.anker === 'end' ? beste.x1 : (beste.x0 + beste.x1) / 2, y: beste.y0 + hoog * 0.78, anker: beste.anker };
      });
      return uit;
    }
    /* HET EZELTJE (Armyan, 19-09-2026: "maak het een beetje dynamisch en speels"): het
       ezeltje uit de kopbalk staat op de gekozen plaats en trot met een veer naar de volgende.
       Eén element buiten de puntengroep, zodat het een verversing van de punten overleeft. */
    const svg = el.kaartPunten ? el.kaartPunten.closest('svg') : null;
    let ezel = null, ezelStand = null, ezelDoel = null, ezelV = { x: 0, y: 0 }, ezelRaf = 0, ezelTik = 0;
    if (svg) {
      ezel = mk('g', { class: 'fri__ezel', 'aria-hidden': 'true' });
      const lijf = mk('g', { class: 'fri__ezel-lijf', transform: 'translate(-23 -45) scale(1.9)' });
      ['M3 16 C3 13 4 11 5.5 10.5 H14.5 C16 10 17 8.5 18 6.5 L20.8 10.8 C21.7 11.9 21.2 12.9 20.1 12.7 L18.4 12.2 C17.8 13.2 17.4 14.5 17.3 15.6 C14 16.3 10 16.3 7 15.5 C5.2 14.5 5 12 5.5 10.5',
       'M7.2 10.5 V7.6 Q7.2 5.5 9.2 5.5 H12.3 Q14.3 5.5 14.3 7.6 V10.5'].forEach(d => lijf.appendChild(mk('path', { d })));
      [[17, 7.8, 15.3, 3.2], [19.2, 8.3, 20.2, 3.2], [7, 15.5, 5.6, 20.5], [14, 16.2, 13.4, 20.5], [17.3, 15.6, 18.4, 20.5]].forEach(([x1, y1, x2, y2]) => lijf.appendChild(mk('line', { x1, y1, x2, y2 })));
      const hop = mk('g', { class: 'fri__ezel-hop' }); hop.appendChild(lijf); ezel.appendChild(hop);
      svg.appendChild(ezel);
    }
    function zetEzel(lat, lon) {
      if (!ezel) return;
      const p = projecteer(lat, lon);
      if (p.x < 0 || p.x > PROJ.w || p.y < 0 || p.y > PROJ.h) { ezel.classList.remove('is-er'); return; }
      ezelDoel = p;
      if (!ezelStand || rustig) { ezelStand = { x: p.x, y: p.y }; ezelV = { x: 0, y: 0 }; ezel.setAttribute('transform', 'translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ')'); ezel.classList.add('is-er'); return; }
      ezel.classList.add('is-er');
      const tik = t => {
        const dt = Math.min(1 / 30, Math.max(1 / 240, ezelTik ? (t - ezelTik) / 1000 : 1 / 60)); ezelTik = t;
        /* dezelfde veer als de stip in de meter: stijfheid 120, demping 22 */
        ezelV.x += (120 * (ezelDoel.x - ezelStand.x) - 22 * ezelV.x) * dt; ezelStand.x += ezelV.x * dt;
        ezelV.y += (120 * (ezelDoel.y - ezelStand.y) - 22 * ezelV.y) * dt; ezelStand.y += ezelV.y * dt;
        /* onderweg kijkt hij de kant op waar hij heen gaat: de kopbalk-ezel kijkt naar rechts */
        const kant = ezelV.x < -8 ? -1 : ezelV.x > 8 ? 1 : (ezel.dataset.kant === '-1' ? -1 : 1);
        ezel.dataset.kant = String(kant);
        const klaar = Math.abs(ezelDoel.x - ezelStand.x) < 0.1 && Math.abs(ezelDoel.y - ezelStand.y) < 0.1 && Math.abs(ezelV.x) < 0.1 && Math.abs(ezelV.y) < 0.1;
        if (klaar) { ezelStand = { x: ezelDoel.x, y: ezelDoel.y }; ezelV = { x: 0, y: 0 }; ezelRaf = 0; }
        ezel.setAttribute('transform', 'translate(' + ezelStand.x.toFixed(1) + ' ' + ezelStand.y.toFixed(1) + ') scale(' + kant + ' 1)');
        if (!klaar) ezelRaf = requestAnimationFrame(tik);
      };
      if (!ezelRaf) { ezelTik = 0; ezelRaf = requestAnimationFrame(tik); }
    }
    /* de opkomst: als de kaart in beeld komt landen de stippen één voor één, tekenen de
       rivieren zich en komen de grenzen op. Daarna staat data-in op 1 en gebeurt het niet meer. */
    if (svg && !rustig && 'IntersectionObserver' in window) {
      svg.dataset.in = '0';
      const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { svg.dataset.in = '1'; io.disconnect(); } }, { threshold: 0.25 });
      io.observe(svg);
    } else if (svg) { svg.dataset.in = '1'; }
    /* de getallen tellen op naar hun stand als er nieuwe cijfers binnenkomen */
    function telOp(sp, naar, vertraging) {
      if (rustig) { sp.textContent = String(naar); return; }
      const t0 = performance.now() + vertraging; const duur = 650;
      const stap = t => { const u = Math.min(1, Math.max(0, (t - t0) / duur)); const e = 1 - Math.pow(1 - u, 3); sp.textContent = String(Math.round(naar * e)); if (u < 1) requestAnimationFrame(stap); };
      requestAnimationFrame(stap);
    }
    let vorigeScores = [];
    function tekenKaart(standen) {
      if (!el.kaartPunten) return;
      const nieuw = standen.map(st => st ? st.score : null);
      const veranderd = nieuw.map((v, i) => v != null && v !== vorigeScores[i]);
      laatsteStanden = standen;
      el.kaartPunten.innerHTML = '';
      const fs = matchMedia('(max-width: 900px)').matches ? 17 : 13;   /* gelijk aan .fri__kaartnaam in donq-p-fructaan.css */
      const plek = plaatsNamen(standen, fs);
      PLAATSEN.forEach(([naam, lat, lon], i) => {
        const p = projecteer(lat, lon), st = standen[i];
        const n = st ? niveauVanScore(st.score) : 'onbekend';
        const g = mk('g', { class: 'fri__punt-knop' + (naam === gekozenPlaats ? ' is-gekozen' : ''), role: 'button', tabindex: '0', 'data-plaats': naam, style: '--v:' + (i * 45) + 'ms' });
        const titel = mk('title', {}); titel.textContent = naam + ': ' + (st ? woord(n).toLowerCase() : 'nog geen gegevens'); g.appendChild(titel);
        /* het raakvlak: 17 eenheden is op een kaart van 340 px nog 10 px rond de stip; Den Haag en Rotterdam staan 35 uit elkaar */
        g.appendChild(mk('circle', { class: 'fri__raak', cx: p.x.toFixed(1), cy: p.y.toFixed(1), r: 17 }));
        g.appendChild(mk('circle', { class: 'fri__kaartstip', 'data-niveau': n, cx: p.x.toFixed(1), cy: p.y.toFixed(1), r: st ? 9.5 : 7 }));
        g.appendChild(mk('circle', { class: 'fri__kaartring', cx: p.x.toFixed(1), cy: p.y.toFixed(1), r: 16 }));
        if (st && veranderd[i] && !rustig) g.appendChild(mk('circle', { class: 'fri__ping', cx: p.x.toFixed(1), cy: p.y.toFixed(1), r: 10 }));
        const pl = plek[naam];
        const t = mk('text', { class: 'fri__kaartnaam', x: pl.x.toFixed(1), y: pl.y.toFixed(1), 'text-anchor': pl.anker });
        t.textContent = naam; g.appendChild(t);
        /* het getal bij de naam, zodat je op de kaart ziet dat elke plaats zijn eigen stand heeft */
        if (st) { const sp = mk('tspan', { class: 'fri__kaartgetal', dx: '7' }); sp.textContent = String(st.score); t.appendChild(sp); if (veranderd[i]) telOp(sp, st.score, i * 45); }
        const kies = () => {
          gekozenPlaats = naam; invoer.value = naam;
          tekenKaart(laatsteStanden);
          toon(lat, lon, naam);
          if (matchMedia('(max-width: 900px)').matches) uitkomst.scrollIntoView({ behavior: rustig ? 'auto' : 'smooth', block: 'start' });
        };
        g.addEventListener('click', kies);
        g.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); kies(); } });
        el.kaartPunten.appendChild(g);
      });
      vorigeScores = nieuw;
    }
    matchMedia('(max-width: 900px)').addEventListener('change', () => tekenKaart(laatsteStanden));
    const klok = t => new Date(t).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
    async function laadKaart() {
      if (!el.kaartPunten) return;
      tekenKaart([]);
      let bewaard = null;
      /* Armyan (16-09): "het moet live, automatisch, zoals die websites". De bewaarde stand
         is alleen het eerste beeld; daarna wordt er bij elk bezoek vers opgehaald, en verder elk
         kwartier en zodra je terugkomt op het tabblad (zie onderaan). */
      try { bewaard = JSON.parse(localStorage.getItem('donq-fructaan-kaart2') || 'null'); } catch (e) {}
      if (bewaard && Date.now() - bewaard.t < 3600e3 && bewaard.standen && bewaard.standen.length === PLAATSEN.length) tekenKaart(bewaard.standen);
      el.kaartStatus.textContent = 'Bijwerken…';
      const url = weerUrl + '?latitude=' + PLAATSEN.map(p => p[1]).join(',') + '&longitude=' + PLAATSEN.map(p => p[2]).join(',') +
        '&hourly=temperature_2m,cloud_cover,is_day&daily=sunrise,sunset,temperature_2m_min,temperature_2m_max,sunshine_duration,precipitation_sum&models=' + MODELLEN.join(',') + '&timezone=Europe%2FAmsterdam&past_days=14&forecast_days=1';
      try {
        const r = await fetch(url); if (!r.ok) throw new Error('http ' + r.status);
        const lijst = (await r.json()); if (!Array.isArray(lijst) || lijst.length !== PLAATSEN.length) throw new Error('onverwacht antwoord');
        lijst.forEach(meng);
        const standen = lijst.map(d => { const reeks = reken(d), hi = uurNu(d, reeks); return { score: totaal(reeks[hi].idx, dagpunten(d.daily, Math.floor(hi / 24))) }; });
        tekenKaart(standen);
        el.kaartStatus.textContent = 'Bijgewerkt om ' + klok(Date.now()) + '.';
        try { localStorage.setItem('donq-fructaan-kaart2', JSON.stringify({ t: Date.now(), standen })); } catch (e) {}
      } catch (e) { el.kaartStatus.textContent = 'De kaart kon nu niet worden bijgewerkt.'; console.warn('[fructaan kaart]', e); }
    }

    /* ---------- de plaats ---------- */
    /* Wat mensen typen is niet wat de geocoder verwacht (Armyan, 17-09: "die info
       blokken werken niet", met "Die plaats vinden we niet" in beeld): "Reek, Nederland",
       "5375 AB", "Sint Oedenrode" zonder streepje, "Den Bosch". Dus eerst schoonmaken,
       dan varianten proberen, en als Open-Meteo niets vindt OpenStreetMap (Nominatim),
       dat ook gehuchten, straten en bijnamen kent. */
    const schoon = t => t.trim().split(',')[0].trim().replace(/^(\d{4})\s*[a-z]{2}$/i, '$1').replace(/\s+/g, ' ');
    function varianten(naam) {
      const n = schoon(naam), l = n.toLowerCase(), uit = [n];
      const alias = { 'den bosch': "'s-Hertogenbosch", 's-hertogenbosch': "'s-Hertogenbosch", 'shertogenbosch': "'s-Hertogenbosch", 's hertogenbosch': "'s-Hertogenbosch", "'s-gravenhage": 'Den Haag', 's-gravenhage': 'Den Haag', 'sgravenhage': 'Den Haag' };
      if (alias[l]) uit.push(alias[l]);
      if (/^(sint|st\.?) /i.test(n)) uit.push(n.replace(/^(sint|st\.?) /i, 'Sint-'));
      if (n.includes('-')) uit.push(n.replace(/-/g, ' '));
      return uit.filter((x, i) => uit.indexOf(x) === i);
    }
    async function zoekOm(naam) {
      const r = await fetch(geoUrl + '?name=' + encodeURIComponent(naam) + '&count=8&language=nl&format=json');
      if (!r.ok) throw new Error('http ' + r.status);
      const d = await r.json(); if (!d || d.error) throw new Error(d && d.reason || 'geocoder');
      return d.results || [];
    }
    async function zoekOsm(naam) {
      const r = await fetch('https://nominatim.openstreetmap.org/search?q=' + encodeURIComponent(naam) + '&format=jsonv2&addressdetails=1&countrycodes=nl,be,lu,de&limit=5&accept-language=nl');
      if (!r.ok) return [];
      const l = await r.json();
      return (Array.isArray(l) ? l : []).filter(x => x.lat && x.lon).map(x => ({
        name: x.name || String(x.display_name || '').split(',')[0], latitude: +x.lat, longitude: +x.lon,
        country_code: String((x.address && x.address.country_code) || 'nl').toUpperCase(), country: x.address && x.address.country,
        admin1: x.address && (x.address.state || ''), population: Math.round((x.importance || 0) * 1e6),
      }));
    }
    async function zoek(naam) {
      const mijn = ++ophaling;
      status.textContent = 'Plaats opzoeken…';
      let results = [];
      try {
        for (const v of varianten(naam)) { results = await zoekOm(v); if (results.length) break; }
        if (!results.length) results = await zoekOsm(schoon(naam));
      } catch (e) { if (mijn === ophaling) status.textContent = 'Plaatsen opzoeken lukt nu even niet. Probeer het zo nog eens.'; console.warn('[fructaan]', e); return; }
      if (mijn !== ophaling) return;
      if (!results.length) { status.textContent = 'Die plaats vinden we niet. Probeer de volledige naam, of alleen de vier cijfers van de postcode.'; return; }
      /* liever een plaats in de Benelux of net over de grens dan een naamgenoot ver weg;
         bij gelijke stand de grootste plaats, en het land erbij als het niet Nederland is */
      const graag = ['NL', 'BE', 'LU', 'DE', 'FR', 'GB'];
      const rang = p => { const i = graag.indexOf(p.country_code); return i < 0 ? 99 : i; };
      const p = results.slice().sort((a, b) => rang(a) - rang(b) || (b.population || 0) - (a.population || 0))[0];
      const label = p.name + (p.country_code !== 'NL' ? ' (' + (p.country || p.country_code) + ')' : (p.admin1 && p.admin1 !== p.name ? ' (' + p.admin1 + ')' : ''));
      gekozenPlaats = PLAATSEN.some(x => x[0] === p.name) ? p.name : '';
      if (el.kaartPunten) el.kaartPunten.querySelectorAll('.fri__punt-knop').forEach(k => k.classList.toggle('is-gekozen', k.dataset.plaats === gekozenPlaats));
      toon(p.latitude, p.longitude, label, mijn);
    }
    form.addEventListener('submit', e => { e.preventDefault(); const v = invoer.value.trim(); if (v) zoek(v); else status.textContent = 'Vul eerst een plaats in.'; });
    if (gps) gps.addEventListener('click', () => {
      if (!navigator.geolocation) { status.textContent = 'Deze browser geeft geen locatie door.'; return; }
      status.textContent = 'Locatie bepalen…';
      navigator.geolocation.getCurrentPosition(
        p => { invoer.value = ''; gekozenPlaats = ''; toon(p.coords.latitude, p.coords.longitude, 'jouw locatie'); },
        () => { status.textContent = 'Locatie ophalen lukte niet. Vul een plaats in.'; },
        { timeout: 10000, maximumAge: 600000 });
    });

    /* bij het openen: de plaats van deze sessie, anders de onthouden plaatsnaam, anders de standaard */
    let onthouden = null;
    try { onthouden = JSON.parse(sessionStorage.getItem('donq-fructaan-plaats') || localStorage.getItem('donq-fructaan-plaats') || 'null'); } catch (e) {}
    if (onthouden && onthouden.lat) {
      if (onthouden.naam !== 'jouw locatie') invoer.value = onthouden.naam.replace(/ \(.*\)$/, '');
      gekozenPlaats = PLAATSEN.some(x => x[0] === onthouden.naam) ? onthouden.naam : '';
      toon(onthouden.lat, onthouden.lon, onthouden.naam);
    } else { invoer.value = blok.dataset.plaats || ''; zoek(blok.dataset.plaats || 'Utrecht'); }
    laadKaart();

    /* wat meetelt en wat je zelf ziet: op een ruim scherm open naast het antwoord, op de telefoon dichtgeklapt */
    const meer = q('[data-fri-meer]');
    if (meer) { const mq = matchMedia('(min-width: 1024px)'); const zet = () => { meer.open = mq.matches; }; zet(); mq.addEventListener('change', zet); }

    /* live blijven (Armyan, 16-09: "het moet automatisch, zoals die websites"): elk kwartier
       opnieuw ophalen, en zodra het tabblad na vijf minuten weer in beeld komt; de kaart en de
       gekozen plek allebei, zonder dat iemand op een knop hoeft te drukken */
    let laatstVers = Date.now();
    const ververs = () => { laatstVers = Date.now(); laadKaart(); if (laatstePlek) toon(laatstePlek.lat, laatstePlek.lon, laatstePlek.naam); };
    setInterval(ververs, 15 * 60e3);
    document.addEventListener('visibilitychange', () => { if (!document.hidden && Date.now() - laatstVers > 5 * 60e3) ververs(); });
  }

  document.querySelectorAll('[data-fructaan]').forEach(start);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-fructaan]').forEach(start));
})();
